/**
 * One `RouteObject`, so the file is `not-found.route.tsx` (singular).
 *
 * **Not lazy, on purpose.** The code-split policy enumerates seven route-level
 * chunks — shell, home, title, table, subscription, lists, auth — and names no
 * system chunk, so these two pages belong to the shell. A lazy chunk here
 * would also have to load over the very network condition that produced the
 * error it is trying to explain.
 *
 * The route resolves nothing and fetches nothing: no `loader` in this repo
 * performs a data read, and this surface has no data at all.
 */
import type { RouteObject } from 'react-router-dom';

import { NotFoundPage } from './NotFoundPage';

export const notFoundRoute: RouteObject = {
  path: '404',
  element: <NotFoundPage />,
};
